import { Banner, OpacitySlide, PopUp } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useGetPopUp, type MainInfoResponse, type PopUpResponse } from "@/shared/server";
import { createDate } from "@/utils";
import { Box, Center } from "@chakra-ui/react";
import dayjs from "dayjs";
import { DateSearchBar } from "../dateSearchBar";

export const TopSection = ({ imgList, catchPraise }: MainInfoResponse) => {
    const { data: popUpData } = useGetPopUp<PopUpResponse>();
    const { MEDIAS } = useDesignMaxTheme();
    const { isTablet, isMobile } = MEDIAS();
    return (
        <Box position="relative" h="100dvh">
            {popUpData && (
                <Center
                    position="absolute"
                    top={isMobile ? "108px" : "144px"}
                    left={isTablet ? "24px" : "auto"}
                    right={isTablet ? "auto" : "80px"}
                    zIndex="9999"
                    gap={isMobile ? "36px" : "24px"}
                    flexDir={isTablet ? "column" : "row"}
                >
                    {popUpData.currentPopups.map((currentPopUp) => {
                        const {
                            fromTo: { endDate },
                        } = currentPopUp;
                        const { currentObj } = createDate();
                        const isExpired = currentObj.valueOf() < dayjs(endDate).valueOf();

                        return isExpired && <PopUp key={currentPopUp.postIdx} currentPopUp={currentPopUp} />;
                    })}
                </Center>
            )}
            <OpacitySlide imgList={imgList}>
                <Banner imgList={imgList} catchPraise={catchPraise} />
                <DateSearchBar isSubMenu />
            </OpacitySlide>
        </Box>
    );
};
